import { initials } from "../lib/format.js";
import { useProfileAvatar } from "../lib/profile-avatar.js";

export function UserAvatar({
  userId,
  name,
  className = "avatar",
}: {
  userId: string;
  name: string;
  className?: string;
}) {
  const avatar = useProfileAvatar(userId);
  return (
    <span className={`${className} user-avatar-image`} aria-hidden="true">
      {!avatar.isError && avatar.data?.image ? (
        <img src={avatar.data.image} alt="" />
      ) : (
        initials(name)
      )}
    </span>
  );
}
